
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { singularityStore } from "@/store/store";
import WPPageManagerPageNew from "./WPPageManagerPageNew.vue";
import WPPageManagerAddPage from "./WPPageManagerAddPage.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";
import SingularityPanelHeader from "../PanelHeader/SingularityPanelHeader.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: {
    TextInput,
    WPPageManagerPageNew,
    WPPageManagerAddPage,
    Dropdown,
    IconButton,
    SingularityPanelHeader,
    NiceButton
  }
})
export default class WPPageManager extends Vue {
  get pages() {
    return singularityStore.pagesInWP.filter(page => page.postType === "page");
  }

  addIsOpen = false;
  openAdd() {
    this.addIsOpen = !this.addIsOpen;
  }
}
